import styled from "styled-components";

export const Warning = styled.h3`
  font-weight: 700;
  font-size: 24px;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.mineShaft};
  margin: 16px auto 32px;
`;
